import { api, apiV2 } from './http';

const unitsPath = buyerId => `/v1/buyers/${buyerId}/purchasing-units`;

export const getPurchasingUnits = (buyerId, params = {}) =>
  apiV2.get(unitsPath(buyerId), { params });

export const createPurchasingUnit = (buyerId, data) => apiV2.post(unitsPath(buyerId), { data });

export const syncPurchasingUnits = buyerId => apiV2.post(`${unitsPath(buyerId)}/sync`);

export const updatePurchasingUnit = (buyerId, unitId, data) =>
  apiV2.patch(`${unitsPath(buyerId)}/${unitId}`, { data });

export const getUserPurchasingUnits = (companyId, companyUserId) =>
  api.get(`/companies/${companyId}/users/${companyUserId}/purchasing-units`);

export const updateUserPurchasingUnits = (companyId, companyUserId, purchasingUnitIds) =>
  api.put(`/companies/${companyId}/users/${companyUserId}/purchasing-units`, {
    purchasingUnitIds,
  });

export const getEligiblePurchasingUnits = () => api.get('/companies/me/purchasing-units/eligible');

export const getPurchasingUnitFilterOptions = () =>
  api.get('/companies/me/purchasing-units/filter-options');
